import { EventType, MatrixEvent } from 'matrix-js-sdk';
import mcli from '.';
import { getSanitizedMDirectContent } from './dmAccountData';
import { getNestedReplyText } from './reply';
const ROOM_STATUS_EVENTS = ['m.room.member', 'm.room.name', 'm.room.topic'];
export const createTEvent = async (mevent, redaction = false) => {
    // ensure we have a MatrixEvent instance (SDK sometimes passes raw objects)
    const evt = mevent && typeof mevent.getRoomId === 'function' ? mevent : new MatrixEvent(mevent || {});
    const room = mcli.getRoom(evt.getRoomId && evt.getRoomId());
    if (!room)
        return;
    // Defense-in-depth: if the SDK has not yet decrypted this encrypted event,
    // try to decrypt it now so the snapshot we hand to Redux carries the
    // cleartext content rather than the `m.bad.encrypted` placeholder. The
    // call is a no-op when the event is already decrypted or not encrypted,
    // and it serialises against any in-flight decryption attempt.
    const isEncrypted = typeof evt.isEncrypted === 'function' && evt.isEncrypted();
    const isEncryptedType = evt.getType && evt.getType() === 'm.room.encrypted';
    if (isEncrypted || isEncryptedType) {
        try {
            await mcli.decryptEventIfNeeded(evt);
        }
        catch {
            // Keep going with placeholder content; a later Decrypted event will
            // rewrite Redux when (or if) decryption finally succeeds.
        }
    }
    const resolvedMembers = [];
    room.getMembers().forEach((m) => {
        resolvedMembers.push({
            userId: m.userId,
            imageUrl: m.getAvatarUrl(mcli.baseUrl, 49, 49, 'crop', true, true) || '',
            name: m.name,
            membership: m.membership || '',
            typing: false,
            roomId: m.roomId,
            presence: m.user?.presence || '',
        });
    });
    const readEventId = room.getEventReadUpTo(mcli.getUserId() || '');
    const remoteEventId = evt?.getId ? evt.getId() : '';
    const txnId = evt?.getTxnId ? evt.getTxnId() : undefined;
    const id = remoteEventId || (txnId ? `~local:${txnId}` : '');
    if (!id)
        return;
    let readState = 0;
    const users = room.getUsersReadUpTo(evt);
    const haveRead = resolvedMembers.filter((member) => users.includes(member.userId));
    readState = resolvedMembers.length === haveRead.length ? 2 : haveRead.length > 0 ? 1 : 2;
    return {
        id,
        txnId,
        type: evt.getType ? evt.getType() : '',
        content: evt.getContent ? evt.getContent() : mevent?.content || {},
        prevContent: evt.getPrevContent ? evt.getPrevContent() : mevent?.prev_content || {},
        sender: evt?.getSender ? evt.getSender() : mevent?.sender || '',
        stateKey: evt?.getStateKey ? evt.getStateKey() : mevent?.state_key,
        timestamp: evt.localTimestamp || (evt.getTs ? evt.getTs() : mevent?.origin_server_ts) || 0,
        roomId: (evt.getRoomId ? evt.getRoomId() : mevent?.roomId || mevent?.room_id || ''),
        replyTo: evt.replyEventId || mevent?.replyEventId || null,
        readState,
        haveRead: haveRead,
        usersRead: haveRead,
        isReadByMe: users.includes(mcli.getUserId() || ''),
        isStatusEvent: ROOM_STATUS_EVENTS.includes(evt.getType ? evt.getType() : ''),
        isSending: id.startsWith('$') ? false : evt.isSending ? evt.isSending() : false,
        isEncrypted: evt.isEncrypted ? evt.isEncrypted() : false,
        isRedacted: redaction || (evt.isRedacted ? evt.isRedacted() : false),
        lastEventRead: readEventId || '',
        replyEvent: getNestedReplyText(evt),
        relation: evt.getRelation ? evt.getRelation() : null,
        threadRootId: evt.threadRootId || mevent?.thread_root || undefined,
    };
};
export async function setDmRoom(roomId, userId) {
    if (mcli != null) {
        const dmRoomMap = {
            ...getSanitizedMDirectContent(),
        };
        // remove it from the lists of any others users
        // (it can only be a DM room for one person)
        Object.keys(dmRoomMap).forEach((id) => {
            const roomList = dmRoomMap[id] || [];
            if (id !== userId) {
                dmRoomMap[id] = roomList.filter((mappedRoomId) => mappedRoomId !== roomId);
            }
        });
        // now add it, if it's not already there
        if (userId) {
            const roomList = dmRoomMap[userId] || [];
            if (!roomList.includes(roomId)) {
                dmRoomMap[userId] = [...roomList, roomId];
            }
        }
        await mcli.setAccountData(EventType.Direct, dmRoomMap);
    }
}
